import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useMemo } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { DataTableFilterType } from '../../utils/typings';

interface Props {
  operator?: DataTableFilterType;
  value?: string;
  onChange: (value: string) => void;
}

export const OperatorFilterPopover = ({ operator, value, onChange }: Props) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleChange = (nextValue: string) => () => {
    state.onChange(nextValue);
    onChange(nextValue);
  };

  const operators = useMemo(() => {
    if (operator === 'boolean') {
      return ['equals', 'not'];
    }
    if (operator === 'string') {
      return ['equals', 'contains'];
    }
    if (operator === 'number') {
      return ['gt', 'gte', 'lt', 'lte', 'equals'];
    }
    if (operator === 'date') {
      return ['lte', 'gte'];
    }
  }, [operator]);

  return (
    <Menu>
      <MenuButton as={Button}>{state.value}</MenuButton>
      <MenuList>
        {operators?.map((operator) => (
          <MenuItem key={operator} onClick={handleChange(operator)}>
            {operator}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
